module.exports = __webpack_public_path__ + "static/media/solution2.ddbd3728.jpg";